<template>
  <div class="ac-snooze ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-s gap-10">
        <button
          type="button"
          class="ac-close-button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="ac-header">
          Dismiss Alert
        </div>
      </div>
    </div>
    <div class="ac-body-container">
      <div class="ac-input-container">
        <div class="ac-input-header">
          Why are you dismissing this alert?
        </div>
        <SACButtonSelect
          :value="actionReason"
          :options="[
            {
              label: 'Customer declined',
              value: 'Dismissed - Invalid',
              show: true,
            },
            {
              label: 'Known Issue/No Action',
              value: 'Dismissed - Known Issue',
              show: true,
            },
          ]"
          :onSelect="(value) => change('actionReason', value)"
        />
        <div
          v-if="error.actionReasonErr"
          class="ac-input-error"
        >
          {{ error.actionReasonErr }}
        </div>
        <div v-if="isSmacAdmin" class="ac-input-container">
          <SACDropdown
            class="margin-top-16"
            placeholder="Select Dismiss Decision"
            :options="dismissOptions"
            :value="selectedDecision"
            field="selectedDecision"
            :change="change"
            :error="error.leadDecisionErr"
            hideSearch
          />
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Notes <span class="ac-input-sub">(Optional)</span>
        </div>
        <textarea
          placeholder="Leave a note here..."
          :value="actionNote"
          @change="change('actionNote', $event.target.value)"
        />
        <div class="ac-text-count">
          500 Character Max
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="sac__button bg-transparent"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="sac__button bg-primary margin-left-16"
        @click="handleNext"
      >
        <span>Next</span>
      </button>
      <ProcessOverlay
        :show="loading"
        text="Dismissing Alert"
      />
    </div>
  </div>
</template>

<script>
import SACButtonSelect from '@shared/components/sac/SACButtonSelect.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import serviceMixin from '@shared/mixins/serviceMixin';
import ActionStatus from '@shared/lib/constant/ActionStatus';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'DismissLead',
  components: {
    ProcessOverlay,
    SACButtonSelect,
    SACDropdown,
  },
  mixins: [serviceMixin],
  props: {
    isAlert: Boolean,
  },
  data() {
    return {
      error: {},
      loading: false,
      selectedDecision: null,
      actionReason: null,
      actionNote: null,
      dismissOptions: [{
        label: 'Poor sensor placement',
        value: 'Poor sensor placement',
      }, {
        label: 'No issue',
        value: 'No issue',
      }],
    };
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    isValid() {
      const error = {};
      if (!this.actionReason) {
        error.actionReasonErr = 'Please select a reason for dismissal.';
      }
      if (this.isSmacAdmin && !this.selectedDecision) {
        error.leadDecision = 'Please select a dismiss decision';
      }
      this.error = error;
      return Object.keys(error).length === 0;
    },
    async dismissAlert() {
      const actionReq = {
        alert: this.selectedAlert,
        actionStatus: ActionStatus.Dismissed,
        actionNote: this.actionNote,
        actionReason: this.actionReason,
      };
      await this.$store.dispatch('dismissAlertForService', actionReq);
    },
    async dismissLead() {
      const actionReq = {
        ...this.actionRequest,
        actionNote: this.actionNote,
        leadDecision: this.selectedDecision,
      };
      await this.$store.dispatch('updateAlertNoticeAction', actionReq);
    },
    async handleNext() {
      if (this.isValid()) {
        this.loading = true;
        let chronicType;
        let chronicNote;
        if (this.isAlert) {
          await this.dismissAlert();
          chronicType = 'alert';
          chronicNote = this.actionNote;
        } else {
          await this.dismissLead();
          chronicType = 'lead';
          chronicNote = this.actionNote;
        }
        this.loading = false;
        this.$store.dispatch('changeServiceValues', [{
          field: 'actionModalView',
          value: 'set-chronic',
        }, {
          field: 'chronicType',
          value: chronicType,
        }, {
          field: 'chronicNote',
          value: chronicNote,
        }]);
      }
    },
  },
};
</script>
